export default [{
  path: '/stage/cashBox',
  name: 'stage-cashBox',
  title: '钱箱管理',
  component: () => import('@/views/stage/template/cashBox/index')
}];
